import { createContext } from 'react'

export default createContext({
  user: {
    profileUrl: null,
    status: null,
    userId: null,
  },
  businesses: [],
  getting: false,
})
